import { useMemo } from 'react';

/**
 * Custom hook to manage dashboard rendering conditions
 * @param {boolean} isWidgetDataLoading - Whether widget data is loading
 * @param {boolean} isGetAgencyLoading - Whether agency data is loading
 * @param {boolean} isAgencyDashboard - Whether this is an agency dashboard
 * @param {Object} agencyDetail - Agency detail data
 * @param {Object} widgetData - Widget data
 * @returns {Object} Rendering conditions
 */
const useDashboardRendering = (
  isWidgetDataLoading,
  isGetAgencyLoading,
  isAgencyDashboard,
  agencyDetail,
  widgetData
) =>
  useMemo(() => {
    const isLoading = isWidgetDataLoading || isGetAgencyLoading;
    const hasData = isAgencyDashboard
      ? agencyDetail && Object.keys(agencyDetail).length > 0
      : !!widgetData;
    const shouldShowWidgets = !isLoading && hasData;
    const shouldShowNoData = !isLoading && !hasData;

    return {
      isLoading,
      hasData,
      shouldShowWidgets,
      shouldShowNoData,
    };
  }, [isWidgetDataLoading, isGetAgencyLoading, isAgencyDashboard, agencyDetail, widgetData]);

export default useDashboardRendering;
